import {
  isRejectedWithValue,
  Middleware,
  MiddlewareAPI,
} from '@reduxjs/toolkit';
import { captureException, configureScope, Severity } from '@sentry/react';
import { toast } from 'react-toastify';
import { logout } from 'store/userDetailsSlice';

export const errorHandlingMiddleware: Middleware =
  (store: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
      const handleError = (errorCode: number) => {
        const codes: Record<any, Function> = {
          401: () => store.dispatch(logout()),
          429: () => {},
          500: () => {
            toast.error('Failed to perform the task', {
              toastId: 'api-error',
            });
            console.error(action);

            configureScope((scope) => {
              scope.setExtra('error payload', action.payload);
              scope.setExtra('error string', JSON.stringify(action));

              scope.setLevel(Severity.Error);
            });
            const errorMessage = new Error(
              `Failed to perform the task ${action}`
            );
            errorMessage.name = '500 Internal Server Error';
            captureException(errorMessage);
          },

          504: () => {},
          default: () => {
            const errorMessage =
              action?.payload?.data?.message || action?.payload?.data?.errors;

            if (errorMessage) {
              toast.error(errorMessage, {
                toastId: 'api-error',
              });
              errorMessage.name = '4XX - 5XX Internal Server Error';
            }

            console.error(action);

            configureScope((scope) => {
              scope.setExtra('error payload', action.payload);
              scope.setExtra('error string', JSON.stringify(action));

              scope.setLevel(Severity.Error);
            });

            captureException(errorMessage || action);
          },
        };

        return errorCode in codes ? codes[errorCode]() : codes['default']();
      };

      handleError(action.payload.status);
    }

    return next(action);
  };
